import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import ProductsShowcase from '../components/sections/ProductsShowcase';
import CTABanner from '../components/sections/CTABanner';
import Container from '../components/ui/Container';
import './Products.css';

const Products = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Flowto.AI Products',
    description: 'Flowto.AI가 만드는 서비스',
    url: 'https://flowto-ai.com/products',
  };

  return (
    <div className="products-page">
      <SEO
        title="프로덕트"
        description="지금 서비스 중인 밋트립과 달리고, 개발 중인 마켓핏 테스터와 잠깐어때, 그리고 생활 도구를 모은 뚝딱."
        url="/products"
        structuredData={structuredData}
      />

      <header className="products-hero">
        <Container>
          <span className="products-hero__eyebrow">Products</span>
          <h1 className="products-hero__title">
            지금 만드는 것,
            <br />
            다음에 만들 것.
          </h1>
          <p className="products-hero__sub">
            운영 중인 서비스부터 개발 중인 것, 실험을 모아 둔 뚝딱까지.
          </p>
        </Container>
      </header>

      <ProductsShowcase hideHeader layout="page" />
      <CTABanner />
    </div>
  );
};

export default Products;
